/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { formatCurrency } from "../../../../utils/format";
import ControlledField from "./ControlledField";

export default function TotalsSection({
  control,
  FloatingNumber,
  getValues,
  totalClosingMeta,
  handleActionButton,
  onDisclaimerClick,
}) {
  const getVal = (path, fallback = "") => {
    try {
      if (typeof getValues === "function") {
        const v = getValues(path);
        return v === undefined ? fallback : v;
      }
    } catch (e) {
      return fallback;
    }
    return fallback;
  };
  const loanType = getVal("loanInfoMeta.buyersLoanType", "Conventional");

  // Estimated Tax Prorations can legitimately be a credit (negative) rather than a debit —
  // the shared cleanNumber (sellerNet.shared.js) strips the sign, so this field needs its
  // own negative-preserving variant instead (paired with FloatingNumber's allowNegative).
  const cleanSignedNumber = (v) => {
    if (v === undefined || v === null) return "";
    const s = typeof v === "string" ? v : String(v);
    const negative = /^\s*-/.test(s);
    const digits = s.replace(/[^0-9.]/g, "");
    return negative && digits ? `-${digits}` : negative ? "-" : digits;
  };

  const renderActionButtons = () => (
    <div className="box-action">
      <ul>
        <li>
          <button
            className="icon-pdf"
          >
            Save PDF
          </button>
          <ul>
            <li>
              <button
                onClick={() => handleActionButton("download")}
              >
                Estimate
              </button>
            </li>
            <li>
              <button
                onClick={() => handleActionButton("downloadQuick")}
              >
                Showcase
              </button>
            </li>
          </ul>
        </li>
        <li>
          <button
            className="icon-print"
          >
            Print
          </button>
          <ul>
            <li>
              <button
                onClick={() => handleActionButton("print")}
              >
                Estimate
              </button>
            </li>
            <li>
              <button
                onClick={() => handleActionButton("printQuick")}
              >
                Showcase
              </button>
            </li>
            {loanType === "Owner Carry" && (
              <li>
                <button
                  onClick={() => handleActionButton("AmortizationSch")}
                >
                  Amortization Sch.
                </button>
              </li>
            )}
          </ul>
        </li>
        <li>
          <button
            className="icon-email"  >
            Email
          </button>
          <ul>
            <li>
              <button
                onClick={() => handleActionButton("email")}
              >
                Estimate
              </button>
            </li>
            <li>
              <button
                onClick={() => handleActionButton("emailQuick")}
              >
                Showcase
              </button>
            </li>
            {loanType === "Owner Carry" && (
              <li>
                <button
                  onClick={() => handleActionButton("AmortizationSch")}
                >
                  Amortization Sch.
                </button>
              </li>
            )}
          </ul>
        </li>
        <li>
          <button
            className="icon-text"
          >
            Text
          </button>
          <ul>
            <li>
              <button
                onClick={() => handleActionButton("text")}
              >
                Estimate
              </button>
            </li>
            <li>
              <button
                onClick={() => handleActionButton("textQuick")}
              >
                Showcase
              </button>
            </li>
          </ul>
        </li>

      </ul>
    </div>
  );

  return (
    <>
      <div className="box-wrap">
        <div className="box-layout-head">
          <h3>Total</h3>
        </div>
        <div className="wrap-middle-container">
          <div className="totl-estimate">
            <div className="totl-estimate-txt heading-c">
              Total All Costs and Credits&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$
            </div>
            <div className="totl-estimate-amnt heading-c">
              {formatCurrency(totalClosingMeta.allCostsTotal) ?? "0.00"}
            </div>
          </div>
          <div className="calc-frm-field b-top mg-top-16 pd-top-16">
            <div className="calc-frm-fld form-group">
              <ControlledField
                name="loanInfoMeta.estimatedTaxProrations"
                control={control}
                defaultValue={getVal("loanInfoMeta.estimatedTaxProrations", "")}
                InputComponent={FloatingNumber}
                placeholder=""
                label="Estimated Tax Prorations $"
                type="text"
                cleanNumber={cleanSignedNumber}
                inputProps={{ allowNegative: true }}
              />
            </div>
          </div>
          
          <div className="totl-estimate box-ly">
            <div className="totl-estimate-txt heading-c">
              Estimated Seller
              Net&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$
            </div>
            <div className="totl-estimate-amnt heading-c">
              {formatCurrency(totalClosingMeta.estimatedSellerNet) || "0.00"}
            </div>
          </div>
        </div>
        {renderActionButtons()}
      </div>

      <div className="calc-frm-field">
        <a
          href="#"
          className="icon-info"
          onClick={(e) => {
            e.preventDefault();
            onDisclaimerClick();
          }}
        >
          Disclaimer
        </a>
      </div>
    </>
  );
}
